var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25278 2.58579C1.62785 2.21071 2.13656 2 2.66699 2H7.33366C7.70185 2 8.00033 2.29848 8.00033 2.66667C8.00033 3.03486 7.70185 3.33333 7.33366 3.33333H2.66699C2.49018 3.33333 2.32061 3.40357 2.19559 3.5286C2.07056 3.65362 2.00033 3.82319 2.00033 4V13.3333C2.00033 13.5101 2.07056 13.6797 2.19559 13.8047C2.32061 13.9298 2.49018 14 2.66699 14H12.0003C12.1771 14 12.3467 13.9298 12.4717 13.8047C12.5968 13.6797 12.667 13.5101 12.667 13.3333V8.66667C12.667 8.29848 12.9655 8 13.3337 8C13.7018 8 14.0003 8.29848 14.0003 8.66667V13.3333C14.0003 13.8638 13.7896 14.3725 13.4145 14.7475C13.0395 15.1226 12.5308 15.3333 12.0003 15.3333H2.66699C2.13656 15.3333 1.62785 15.1226 1.25278 14.7475C0.877706 14.3725 0.666992 13.8638 0.666992 13.3333V4C0.666992 3.46957 0.877706 2.96086 1.25278 2.58579Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3337 1.91912C13.1354 1.91912 12.9453 1.99788 12.8051 2.13807L6.60232 8.34083L6.24992 9.75042L7.65951 9.39802L13.8623 3.19526C14.0025 3.05507 14.0812 2.86493 14.0812 2.66666C14.0812 2.4684 14.0025 2.27826 13.8623 2.13807C13.7221 1.99788 13.5319 1.91912 13.3337 1.91912ZM11.8623 1.19526C12.2525 0.80502 12.7818 0.585785 13.3337 0.585785C13.8856 0.585785 14.4148 0.80502 14.8051 1.19526C15.1953 1.5855 15.4146 2.11478 15.4146 2.66666C15.4146 3.21855 15.1953 3.74783 14.8051 4.13807L8.47174 10.4714C8.3863 10.5568 8.27925 10.6175 8.16203 10.6468L5.49536 11.3134C5.26818 11.3702 5.02786 11.3037 4.86227 11.1381C4.69668 10.9725 4.63012 10.7322 4.68691 10.505L5.35358 7.83831C5.38288 7.72109 5.4435 7.61403 5.52894 7.52859L11.8623 1.19526Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.92b446f79042c5be2b05e73190101609.svg";